import { Dropdown } from 'antd';
import { observer } from 'mobx-react-lite';
import { useState } from 'react';

import { ReactComponent as ArrowIcon } from 'src/shared/assets/icons/arrow-thin.svg';
import { Button } from 'src/shared/components/button';
import { TOption } from 'src/store/directories/types';

import styles from './removable-row-item-dropdown.module.scss';

type Props = {
  buttonLabel: string;
  options: TOption[];
  onNewSection: (sectionType: string | number) => void;
};

export const SectionDropdown = observer(function SectionDropdown({ buttonLabel, options, onNewSection }: Props) {
  const [isDropdownOpened, setIsDropdownOpened] = useState(false);

  const handleOpenDropdown = (): void => setIsDropdownOpened(true);
  const handleVisibleChange = (is: boolean): void => setIsDropdownOpened(is);

  return (
    <Dropdown
      visible={isDropdownOpened}
      className={styles.sectionDropdown}
      trigger={['click']}
      onVisibleChange={handleVisibleChange}
      overlay={
        <ul className={styles.wrapper}>
          {options.map((option) => {
            const handleAddNewSection = (): void => {
              onNewSection(option.value);
              setIsDropdownOpened(false);
            };

            return (
              <li key={option.value} className={styles.itemWrapper} onClick={handleAddNewSection}>
                <p className={styles.itemText}>{option.label}</p>
              </li>
            );
          })}
        </ul>
      }
    >
      <Button
        width={220}
        variant="secondary"
        icon={<ArrowIcon transform={isDropdownOpened ? 'rotate(180)' : undefined} className={styles.arrowIcon} />}
        onClick={handleOpenDropdown}
      >
        <p>{buttonLabel}</p>
      </Button>
    </Dropdown>
  );
});
